import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
@Component({
    selector: 'app-routing-helper',
    templateUrl: './routing.component.html'
})
export class RoutingComponent implements OnInit {

    constructor(private activatedRoute: ActivatedRoute, private router: Router) { }
    url = "";
    ngOnInit() {
        this.activatedRoute.queryParams.subscribe((params: Params) => {
            this.url = params['url'];
            if (this.url !== undefined && this.url !== null){
                this.router.navigateByUrl(decodeURIComponent(this.url));
            }
        });
    }
}